import styled from 'styled-components'
import Box from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'

export const ZonesCategorySliderWrapper = styled(Box)`
    position: relative;
    width: 100%;
    overflow: hidden;
    border-radius: 8px;

    @media ${respondAbove.xl} {
        min-width: 372px;
        width: 372px;
        margin-right: -8px !important;
    }

    img {
        width: 246px;
        height: 152px;
        object-fit: cover;
        border-radius: 8px;

        @media ${respondAbove.md} {
            width: 348px;
            height: 238px;
        }
    }

    .swiper-slide {
        width: auto;
    }
`
